export default {
  'xeHentai WebUI': '绅士WebUI',
  'Cancel': '取消',
  'Add': '添加',
  'Confirm': '确定',
  'Configuration': '配置',
  'Task Configuration': '任务设置',
  'Add Task': '添加任务',
  'disconneted': '未连接',
  'Running threads': '运行线程',
  'Zombie threads': '抽风线程',
  'Queued images': '待下载图片',
  'Finished images': '已下载图片',
  'Finished': '已完成',
  'Paused': '暂停中',
  'Running': '下载中',
  'Failed': '失败',
  'Successfully connected to xeHentai': '已连接到xeHentai',
  'Task #{0} {1} failed: {2}': '任务 #{0} {1}操作失败: {2}',
  'EroHon': '好多本子',
  'Progress': '进度',
  'RPC Error: {0}': 'RPC 请求失败: {0}',
  'Network Error': '网络错误',
  'Endpoint not set': '没有配置连接',
  'Forbidden': '密钥错误',
  'Connection Configuration': '连接设置',
  'Server': '服务器',
  'Host': '主机名',
  'Port': '端口',
  'Secret': '密钥',
  'Auto Refresh': '自动刷新',
  'Basic Configuration': '基本设置',
  'Advanced Configuration': '高级设置',
  'seconds': '秒',
  'Download directory': '下载目录',
  'Download original': '下载原图',
  'Rename': '重命名',
  'Japanese title': '日语标题',
  'Proxy': '代理',
  'Add Proxy': '添加代理',
  'Use proxy': '使用代理',
  'Proxy image only': '仅代理图片',
  'Make archive': '制作压缩包',
  'Scan thread': '扫描线程数',
  'Download thread': '下载线程数',
  'Download timeout': '下载超时',
  'Low speed threshold': '低速重试阈值',
  'Ignored errors': '忽略错误',
  'Add Errno': '添加错误号',
  'Log path': '日志路径',
  'Log verbose': '日志详细等级',
  'Save tasks': '保存任务',
  'Delete files': '自动删除文件',
  '"{0}" is not a valid proxy string': '"{0}" 不是合法的代理格式',
  '"{0}" is not a valid error number': '"{0}" 不是合法的错误号',
  'Successfully add task #{0}': '成功新建任务 #{0}',
  'Single Page': '单页模式',
  'Double Page': '双页模式',
  'This WebUI don\'t supports xeHentai earlier than {0}': '这个版本的Web界面可能不兼容{0}以前的xeHentai',
  'To add multiple tasks, input one line per URL': '如需添加多个任务，可以每行填写一条URL',
  'Type to search': '搜索本子'
}



// WEBPACK FOOTER //
// ./src/assets/i18n/zh-hans.js